import React from 'react';
import { FaFacebookF, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { motion } from 'framer-motion';
 
const icons = [
    {
        href: 'https://www.facebook.com/profile.php?id=61572863939608',
        icon: <FaFacebookF />,
        color: 'text-[#4267B2]',
        hover: 'hover:text-white hover:bg-[#4267B2]',
    },
    {
        href: 'https://www.linkedin.com/company/glowtech-solutions/',
        icon: <FaLinkedinIn />,
        color: 'text-[#0077B5]',
        hover: 'hover:text-white hover:bg-[#0077B5]',
    },
    {
        href: 'https://www.instagram.com/glowtech_solutions?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
        icon: <FaInstagram />,
        color: 'text-[#E4405F]',
        hover: 'hover:text-white hover:bg-[#E4405F]',
    },
];
 
const SocialSidebar = () => {
    return (
        <div className="fixed top-1/2 left-0 z-50 -translate-y-1/2">
            <div className="bg-white rounded-r-md shadow-md p-2 flex flex-col items-center space-y-4">
                {icons.map((item, index) => (
                    <motion.a
                        key={index}
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`w-10 h-10 flex items-center justify-center rounded ${item.color} ${item.hover} transition duration-300 ease-in-out`}
                        animate={{
                            scale: [1, 1.5, 1.5, 1],
                        }}
                        transition={{
                            duration: 1.5,
                            repeat: Infinity,
                            repeatDelay: 1,
                            delay: index * 0.5,
                        }}
                    >
                        {item.icon}
                    </motion.a>
                ))}
            </div>
        </div>
    );
};
 
export default SocialSidebar;